<template>
  <skeleton theme="opacity" style="width:100%;" shape="radius" bg-color="#dcdcdc">
    <div class="quick-response-item">
      <div class="list-quick-response-content" style="padding-left: 11px">
        <v-layout column>
          <tb-skeleton :aspect-ratio="0.1" style="padding-bottom: 19px; margin-bottom: 5px" width="100%"></tb-skeleton>
          <tb-skeleton :aspect-ratio="0.1" style="padding-bottom: 19px; margin-bottom: 5px" width="100%"></tb-skeleton>
        </v-layout>
      </div>
      <div class="list-quick-response-action" style="padding-right: 5px">
        <v-layout>
          <v-spacer/>
          <tb-skeleton :aspect-ratio="0.1" style="padding-bottom: 19px; margin-bottom: 5px" width="50%"></tb-skeleton>
        </v-layout>
      </div>
    </div>
  </skeleton>
</template>

<script>
export default {
  name: "AgentQuickResponseLoading"
}
</script>

<style scoped lang="scss">
@import "components/style/agent-quick-response";
</style>
